module.exports = __webpack_public_path__ + "static/img/download.34308622.png";